import React, { useState, useEffect, useRef } from "react";
import {
  useAuthErrorMessage,
  useAuthSuccessMessage,
  webAuth,
} from "../utils/userJourneyHelper";

import styles from "./AuthLogin.module.css";

function AuthLogin() {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    rememberMe: false,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useAuthErrorMessage();
  const [successMessage, setSuccessMessage] = useAuthSuccessMessage();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage();
    setError();
    setLoading(true);
    if (formData.rememberMe) {
      const duration = new Date(
        new Date().setFullYear(new Date().getFullYear() + 1)
      ).getTime(); // 1 Year
      localStorage.setItem("remember_me", duration);
    } else {
      const duration = new Date(
        new Date().setHours(new Date().getHours() + 1)
      ).getTime(); // 1 Hour
      localStorage.setItem("session", duration);
    }

    webAuth.login(
      {
        realm: "Username-Password-Authentication",
        username: formData.email,
        password: formData.password,
      },
      ({ error_description }) => {
        if (error_description) {
          setError(error_description);
          setLoading(false);
        }
      }
    );
    setLoading(false);
  };

  const el = useRef(null);

  useEffect(() => {
    if (error && el.current) {
      el.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [error]);

  return (
    <div className={styles.auth}>
      <span
        style={{
          boxSizing: "border-box",
          display: "inline-block",
          overflow: "hidden",
          width: "initial",
          height: "initial",
          background: "none",
          opacity: 1,
          border: "0px",
          margin: "0px",
          padding: "0px",
          position: "relative",
          maxWidth: "100%",
        }}
      >
        <span
          style={{
            boxSizing: "border-box",
            display: "block",
            width: "initial",
            height: "initial",
            background: "none",
            opacity: 1,
            border: "0px",
            margin: "0px",
            padding: "0px",
            maxWidth: "100%",
          }}
        >
          <img
            alt=""
            aria-hidden="true"
            src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%271440%27%20height=%27899%27/%3e"
            style={{
              display: "block",
              maxWidth: "100%",
              width: "initial",
              height: "initial",
              background: "none",
              opacity: 1,
              border: "0px",
              margin: "0px",
              padding: "0px",
            }}
          />
        </span>
        <img
          alt=""
          srcSet="https://cdn.irishfunds.ie/3871x2582/96df9d4546/irish-funds-conference-2024-083.jpg/m/1440x0/filters:quality(80)?_w=1440 1x, https://cdn.irishfunds.ie/3871x2582/96df9d4546/irish-funds-conference-2024-083.jpg/m/1440x0/filters:quality(80)?_w=1440 2x"
          src="https://cdn.irishfunds.ie/3871x2582/96df9d4546/irish-funds-conference-2024-083.jpg/m/1440x0/filters:quality(80)?_w=1440"
          decoding="async"
          data-nimg="intrinsic"
          style={{
            position: "absolute",
            inset: "0px",
            boxSizing: "border-box",
            padding: "0px",
            border: "medium",
            margin: "auto",
            display: "block",
            width: "0px",
            height: "0px",
            minWidth: "100%",
            maxWidth: "100%",
            minHeight: "100%",
            maxHeight: "100%",
            objectFit: "cover",
          }}
        />
      </span>
      <section
        className={`${styles.auth_section} ${styles.login} ${
          styles.hasNotice
        } ${loading && styles.loading}`}
      >
        <div className={styles.header}>
          <svg
            role="presentation"
            viewBox="0 0 644 228"
            preserveAspectRatio="none"
            className={styles.shape}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.01758 -290.458L1006.94 473.78L1124.9 210.611L7.01758 -290.458Z"
              fill="#009247"
            ></path>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M1125.6 209.059L-110.246 -28.8413L7.71373 -292.01L1125.6 209.059Z"
              fill="#3FAE48"
            ></path>
          </svg>
          <div className={styles.logo}>
            <span
              style={{
                boxSizing: "border-box",
                display: "inline-block",
                overflow: "hidden",
                width: "initial",
                height: "initial",
                background: "none",
                opacity: 1,
                border: "0px",
                margin: "0px",
                padding: "0px",
                position: "relative",
                maxWidth: "100%",
              }}
            >
              <span
                style={{
                  boxSizing: "border-box",
                  display: "block",
                  width: "initial",
                  height: "initial",
                  background: "none",
                  opacity: 1,
                  border: "0px",
                  margin: "0px",
                  padding: "0px",
                  maxWidth: "100%",
                }}
              >
                <img
                  alt=""
                  aria-hidden="true"
                  src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2772%27%20height=%2734%27/%3e"
                  style={{
                    display: "block",
                    maxWidth: "100%",
                    width: "initial",
                    height: "initial",
                    background: "none",
                    opacity: 1,
                    border: "0px",
                    margin: "0px",
                    padding: "0px",
                  }}
                />
              </span>
              <img
                alt="Irish Funds Logo"
                src="/assets/img/IFlogo-white-small.png?_w=72"
                decoding="async"
                data-nimg="intrinsic"
                srcSet="/assets/img/IFlogo-white-small.png?_w=72 1x, /assets/img/IFlogo-white-small.png?_w=72 2x"
                style={{
                  position: "absolute",
                  inset: "0px",
                  boxSizing: "border-box",
                  padding: "0px",
                  border: "medium",
                  margin: "auto",
                  display: "block",
                  width: "0px",
                  height: "0px",
                  minWidth: "100%",
                  maxWidth: "100%",
                  minHeight: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                }}
              />
              <noscript></noscript>
            </span>
          </div>
        </div>
        <form
          className={`${styles.loginForm} ${styles.login}`}
          ref={el}
          onSubmit={handleSubmit}
        >
          <span className={styles.welcome}>Welcome back</span>
          <h1 className={styles.heading}>Log in to your account</h1>
          {error && <p className={styles.error}>Error: {error}</p>}
          {successMessage && <p className={styles.success}>{successMessage}</p>}
          <div className={styles.fields}>
            {false && (
              <div
                className={`${styles.alert} ${styles.success} ${styles.hasNotice}`}
              >
                <p>
                  All Members - We have recently relaunched our Member Portal.{" "}
                  <b>Your current password </b>will not work - you will need to
                  re-set it via{" "}
                  <a target="_self" href="/Auth/ForgotPassword/">
                    Forgot password
                  </a>{" "}
                  link.
                </p>
              </div>
            )}

            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              required
              name="email"
              placeholder="Email"
              onChange={handleChange}
            />
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              required
              name="password"
              placeholder="Password"
              onChange={handleChange}
            />
            <div className={styles.agreement}>
              <div>
                <input
                  type="checkbox"
                  id="DecisionBox"
                  className={`${styles.visually_hidden} ${styles.checkbox}`}
                  name="rememberMe"
                  onChange={handleChange}
                />
                <label htmlFor="DecisionBox">Remember me</label>
              </div>
              <a href="/Auth/ForgotPassword/">Forgot password?</a>
            </div>
            <button
              type="submit"
              className={`${styles.loginButton} ${styles.loginButton_secondary}`}
            >
              Log in now
            </button>
          </div>
          <div
            data-lastpass-icon-root=""
            style={{
              position: "relative !important",
              height: "0px !important",
              width: "0px !important",
              float: "left !important",
            }}
          ></div>
          <div
            data-lastpass-icon-root=""
            style={{
              position: "relative !important",
              height: "0px !important",
              width: "0px !important",
              float: "left !important",
            }}
          ></div>
        </form>
        <div className={styles.footer}>
          <h2>
            Dont have an account? <a href="/Auth/Register/">Register today</a>
          </h2>
          <p>
            Please note: portal accounts are only available to contacts from
            Irish Funds member companies.
          </p>
          <div style={{ flexDirection: "row" }}>
            <p>
              If you experience any issues while using this portal, please
              contact us at {" "}
              <a href="mailto:memberportal@irishfunds.ie">
                memberportal@irishfunds.ie
              </a>{" "}
              or call us on {" "}
              <a target="_self" href="tel:+353 (0) 1 675 3200">
                +353 (0) 1 675 3200
              </a>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AuthLogin;
